'use strict';

const _ = require('underscore');

module.exports = class Pagination {
    constructor(totalCount, prevCursor, prevMore, nextCursor, nextMore) {
        this._totalCount = totalCount;
        this._prevCursor = prevCursor;
        this._prevMore = prevMore;
        this._nextCursor = nextCursor;
        this._nextMore = nextMore;
    }

    get totalCount() {
        return this._totalCount;
    }

    get prevCursor() {
        return this._prevCursor;
    }

    get prevMore() {
        return this._prevMore;
    }

    get nextCursor() {
        return this._nextCursor;
    }

    get nextMore() {
        return this._nextMore;
    }
};



// WEBPACK FOOTER //
// ./framework/domain/value/pagination.js